import Swal from "sweetalert2";
import { store } from "../Redux/store";
import { authLogout, cashierCheckOut, selectToken, setToken } from "../Redux/Auth/AuthSlice";
import axios from "axios";

const getBaseUrl = () => {
  const environment = process.env.NODE_ENV || "development";
  switch (environment) {
    case "development":
      return process.env.REACT_APP_API_DEV;
    case "staging":
      return process.env.REACT_APP_API_STAGING;
    case "production":
      return process.env.REACT_APP_API_PRODUCTION;
    default:
      return process.env.REACT_APP_API_DEV;
  }
};

export const apiRequest = axios.create({
  baseURL: getBaseUrl(),
  withCredentials: true,
});

// apiRequest.interceptors.request.use(
//   function (config) {
//     const token = selectToken(store.getState());

//     config.headers.Authorization = "Bearer " + token;
//     config.headers.Pathname = window.location.pathname;

//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

// export const apiRequestGet = async (url, params = {}) => {
//   try {
//     const state = store.getState();
//     const token = state.auth.token;
//     const response = await axios.get(getBaseUrl() + url, {
//       params: params,
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Pathname : window.location.pathname
//       },
//     });

//     if(response.data.status === 'Err' || response.data.status === 'Unauthorized') return { error: true, result: response.data.message};
//     return { error: false, result: response.data.data };
//   } catch (error) {
//     return { error: error.response.data.message, result: [] };
//   }
// };

// export const apiRequestPost = async (url, body = {}) => {
//   try {
//     const state = store.getState();
//     const token = state.auth.token;
//     const response = await axios.post(getBaseUrl() + url, body, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Pathname : window.location.pathname
//       },
//     });

//     if(response.data.status === 'Err' || response.data.status === 'Unauthorized') return { error: true, result: response.data.message};
//     return { error: false, result: response.data.data, pagination: response.data.pagination};
//   } catch (error) {
//     return { error: error.response.data.message, result: [] };
//   }
// };

// === REQUEST INTERCEPTOR ===
apiRequest.interceptors.request.use(
  (config) => {
    const token = selectToken(store.getState());
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers.Pathname = window.location.pathname;
    return config;
  },
  (error) => Promise.reject(error)
);

// === RESPONSE INTERCEPTOR ===
apiRequest.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      console.log(error.response?.status)
      originalRequest._retry = true;
      try {
        const res = await axios.post(
          `${getBaseUrl()}/auth/refresh`,
          {},
          { withCredentials: true }
        );
        const newAccessToken = res.data.accessToken;
        
        store.dispatch(setToken({token:newAccessToken}));

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return apiRequest(originalRequest);
      } catch (err) {
        store.dispatch(authLogout());
        store.dispatch(cashierCheckOut());
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

// === HELPER UNTUK HANDLE RESPONSE ===
const handleResponse = (response) => {
  const { status, data, message, pagination } = response.data;

  if (status === "Err" || status === "Unauthorized") {
    return { error: true, result: message };
  }

  return {
    error: false,
    result: data,
    pagination: pagination ?? null,
  };
};

// === HELPER UNTUK HANDLE ERROR ===
const handleError = (error) => {
  console.log({error})
  const message =
    error?.response?.data?.message || error?.message || "Terjadi kesalahan";
  return { error: true, result: message };
};

// === FUNGSI REQUEST GENERIK ===
export const apiRequestGet = async (url, params = {}) => {
  try {
    const response = await apiRequest.get(url, { params });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const apiRequestPost = async (url, body = {}) => {
  try {
    const response = await apiRequest.post(url, body);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const apiRequestPut = async (url, body = {}) => {
  try {
    const response = await apiRequest.put(url, body);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const apiRequestDelete = async (url, params = {}) => {
  try {
    const response = await apiRequest.delete(url, { params });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};
